import { ValidationLengthUnder10 } from '..';
import { ValidationEisuzi } from '../validation-eisuzi';
import { ValidationMax10Billion } from '../validation-max-10-billion';
import { ValidationLengthUnder1 } from '../_validation-length-under-1';

export const MasterCustomerRankFinalCompleteDateValidation = (
  name: string,
  abbreviation: string,
  date: string,
) => {
  window.console.log();
  return (
    // 必須
    !name
    || !abbreviation
    || !date

  // バリデーション
  || ValidationEisuzi.filter((v) => !v.run(String(abbreviation || ''))).length
  );
};
